// Arquivo gerado por scripts/gerar-versao.js. Não editar.
export const versao = {
  "versao": "1.0.4",
  "commit": "95f11055",
  "dataBuild": "2026-11-04T17:52:19.172Z"
};
